import $ from 'jquery';
import slick from "slick-carousel";

export default function int_carousel(){
    $('.elements-carousel-actuality').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        autoplaySpeed: 2000,
        nextArrow: false,
        prevArrow: false,
        responsive:[
            {
                breakpoint: 640,
                settings:{
                    variableWidth: true,
                }
            }
        ]
    })
}